import React, { Component } from 'react';
import { connect } from 'react-redux';
import TitleDropdowns from '../containers/titlefees/TitleDropdowns';
import Liens from '../containers/titlefees/Liens';
import LemonLaw from '../containers/titlefees/LemonLaw';
import LateFee from '../containers/titlefees/LateFee';
import FastTitle from '../containers/titlefees/FastTitle';
import TitleTotal from '../containers/titlefees/TitleTotal';
import MobileHome from '../containers/titlefees/TotalMobileHomeFee';


class TitleFees extends Component {
  render() {
    const { monthsFromNow } = this.props;
    return (
      <div className="Box">

        <div className="Title">
          <div className="Title-mask" style={{ display: monthsFromNow ? 'none' : 'block' }}></div>
          <TitleDropdowns />
          <MobileHome />
          <Liens />
          <LemonLaw />
          <LateFee />
          <FastTitle />
          <TitleTotal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    monthsFromNow: state.registration.monthsFromNow,
  };
};

export default connect(mapStateToProps)(TitleFees);



// WEBPACK FOOTER //
// ./src/sections/TitleFees.js